const binder = {
    bindToAll: (event: ('click'), selector: string, callback: (e: Event) => void) => {
        document.querySelectorAll(selector).forEach(function (element) {
            element.addEventListener(event, callback);
        });
    },
    executeForAll: (selector: string, callback: (element: Element) => void) => {
        document.querySelectorAll(selector).forEach(function (element) {
            callback(element);
        });
    }
}

export default binder;